module.exports = __webpack_public_path__ + "static/media/add.4f117f7f.svg";